export const arrowDownPath = "<path d=\"M8 3 V13 M4 9 L8 13 L12 9\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
